export const getTotalApplication = (state) => state.applications.totalCount
export const getFormValues = (state) => state.applications.formValues
export const getOfferToPerson = (state) => state.applications.offerToPerson
export const getFilterJobID = (state) => state.applications.filterJobID
export const getEmployerInfo = (state) => state.companyProfile.userData
export const getOfferedFromLightEntre = (state) =>
  state.applications.offeredFromLightEntre
